import Vue from "vue";
import Router from "vue-router";

import GameView from "./views/GameView.vue";
import CRTKView from "./views/CRTKView.vue";
import LandingView from "./views/LandingView.vue";
import UAUView from "./views/UAUView.vue";
import CorreView from "./views/CorreView.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/dreamcatcher",
      component: GameView
    },
    {
      path: "/",
      component: LandingView
    },
    {
      path: "/crtk",
      component: CRTKView
    },
     {
      path: "/crtk/corre",
      component: CorreView
    },
    {
      path: "/uau",
      component: UAUView
    }
  ]
});